function Zero(){
    // private
    function getInputDataLength(inputData){
        for (var datasetId in inputData){
            return inputData[datasetId].length;
        }

        return 0;
    }

    // public
    this.derive = function(inputData, inputDataParameters, derivedDataDatasetId){
        var derivedData = [];
        var inputDataLength = getInputDataLength(inputData);

        for (var i=0; i<inputDataLength; ++i){
            var zeroData = getZeroDataOfIndex(i);
            derivedData.push(zeroData);
        }

        return derivedData;

        function getZeroDataOfIndex(index){
            var timestamp;

            for (var datasetId in inputData){
                if (inputData[datasetId][index] != null){
                    timestamp = inputData[datasetId][index].timestamp;
                }
            }

            return {
                dataset: derivedDataDatasetId,
                value: 0,
                timestamp: timestamp
            };
        }
    }
}

module.exports = new Zero();


// WEBPACK FOOTER //
// ./src/core/services/data-service/derived-datasets/zero.js